import React, { useRef, useEffect } from "react";
import { Resizable } from "re-resizable";

import "./tool_tip.css";

const ToolTipPopup = ({
  onClose,
  position,
  children,
  onResize,
  onResizeStart,
  onResizeStop,
  size,
  isResized,
  isShifted,
  isFlipped,
  minWidth,
  minHeight,
}) => {
  const popupRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  let containerClassName = isResized ? "" : "tooltip-popup-container";
  if (!isResized && isShifted) {
    containerClassName += " shifted";
  }
  if (!isResized && isFlipped) {
    containerClassName += " flipped";
  }

  return (
    <div
      ref={popupRef}
      className={`${containerClassName} tooltip-popup`}
      style={{
        top: position.y,
        left: position.x,
      }}
    >
      <Resizable
        className="tooltip-resizable"
        size={size}
        onResizeStart={onResizeStart}
        onResize={onResize}
        onResizeStop={onResizeStop}
        minWidth={minWidth}
        minHeight={minHeight}
        enable={{
          top: true,
          right: true,
          bottom: true,
          left: true,
          topRight: false,
          bottomRight: false,
          bottomLeft: false,
          topLeft: false,
        }}
      >
        {children}
      </Resizable>
    </div>
  );
};

export default ToolTipPopup;


// WEBPACK FOOTER //
// ./src/components/tool_tips/toolTipPopUp.js